import React, { ReactNode } from "react";
import useAutoLogIn from "./useAutoLogIn";

function AutoLoginProvider({ children }: { children: ReactNode }) {
  const shouldLogIn = useAutoLogIn();
  if (shouldLogIn) {
    return null;
  }

  return <>{children}</>;
}

export default AutoLoginProvider;
